"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var useComponentVisible_1 = __importDefault(require("../../../../app/components/hooks/useComponentVisible"));
var __1 = require("../../..");
var react_ga4_1 = __importDefault(require("react-ga4"));
var use_debounce_1 = require("use-debounce");
var SearchGame = function () {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, react_1.useState)(""), value = _b[0], setValue = _b[1];
    var debounceValue = (0, use_debounce_1.useDebounce)(value, 500)[0];
    var _c = (0, react_1.useState)([]), list = _c[0], setList = _c[1];
    var _d = (0, useComponentVisible_1.default)(true), ref = _d.ref, isComponentVisible = _d.isComponentVisible, setIsComponentVisible = _d.setIsComponentVisible;
    var _e = (0, react_1.useState)(false), isSearch = _e[0], setIsSearch = _e[1];
    var _f = (0, react_1.useState)(false), haveRequest = _f[0], setHaverequest = _f[1];
    (0, react_1.useEffect)(function () {
        setHaverequest(true);
        if (debounceValue && debounceValue.length > 0) {
            axios_1.default.get("/app/game/search/".concat(debounceValue))
                .then(function (response) {
                if (__1.SETUP_LOCAL_APP) {
                    react_ga4_1.default.initialize(__1.GA_ID);
                    var items_1 = [];
                    response.data.forEach(function (item) {
                        items_1.push({
                            item_name: item.name,
                            item_id: item.id
                        });
                    });
                    react_ga4_1.default.event("select_item", {
                        items: items_1
                    });
                }
                setList(response.data);
            }).finally(function () {
                setHaverequest(false);
            });
            setIsComponentVisible(true);
        }
    }, [debounceValue]);
    var style = {
        maxWidth: '475px'
    };
    function handleFocus() {
        setIsSearch(true);
    }
    function handleBlur() {
        setTimeout(function () {
            setIsSearch(false);
        }, 100);
        //setIsSearch(false);
    }
    function handleCloseSearch() {
        setIsSearch(false);
        setValue('');
    }
    (0, react_1.useEffect)(function () {
        if (!isSearch) {
            setValue('');
        }
    }, [isSearch]);
    (0, react_1.useEffect)(function () {
        setList([]);
    }, [value]);
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { onBlur: handleBlur, style: (isSearch) ? style : {}, className: (0, classnames_1.default)("wrap-search-components", (isSearch) ? "wrap-search-components-active" : "") },
            react_1.default.createElement("div", { style: isSearch ? { padding: "8px 16px" } : {}, className: "__search" },
                isSearch &&
                    react_1.default.createElement("img", { style: { height: "20px", width: "24px" }, alt: "search", className: "__left-side-image ", src: "/images/web/search.svg" }),
                react_1.default.createElement("input", { placeholder: t("search_game.input.placeholder"), value: value, onFocus: handleFocus, onChange: function (e) { setValue(e.target.value); } }),
                isSearch
                    ?
                        react_1.default.createElement("img", { onClick: handleCloseSearch, style: { cursor: 'pointer' }, src: "/images/web/icons8_minus.svg" })
                    :
                        react_1.default.createElement("img", { alt: "search", style: { height: "20px", width: "24px" }, src: "/images/web/search.svg" })),
            react_1.default.createElement("div", { className: "__result" }, debounceValue && debounceValue.length > 0 && isComponentVisible &&
                react_1.default.createElement("div", { ref: ref, className: "search-result-link" },
                    list.length == 0 && !haveRequest && react_1.default.createElement("div", { style: { padding: "10px" } }, t("search_game.not_result.text")),
                    list.map(function (item, index) { return react_1.default.createElement("a", { key: index, href: item.link }, item.name); }))))));
};
exports.default = SearchGame;
